import { createAction, props } from '@ngrx/store';

export const requestNotificationPermission = createAction(
  '[Connect] Request notification permission',
);

export const setNotificationPermissionResult = createAction(
  '[Connect] Set notification permission result',
  props<{ result: NotificationPermission }>(),
);

export const showCallNotification = createAction(
  '[Connect] Show the notification when someone is calling',
);
